import React from "react"
import { Container, Fade } from "@mui/material"
import ITEMS from "../header-items.json"
import * as HeaderStyles from "../header.styles"
import LoginIcon from "../../../assets/icons/login.svg"
import CustomButton from "../../custom-button/custom-button.component"
import CloseIcon from "@mui/icons-material/Close"
import CopiaLogo from "../../../assets/icons/why-use-logo.svg"

import * as S from "./menu-mobile.styles"

const MenuMobile = ({ isActiveMenu, handleToggleMenu }) => {
  return (
    <Fade in={isActiveMenu} mountOnEnter unmountOnExit>
      <S.Wrapper>
        <Container>
          <S.TopContainer>
            <CopiaLogo className="logo" />
            <S.CloseButton onClick={handleToggleMenu}>
              <CloseIcon />
            </S.CloseButton>
          </S.TopContainer>
          <S.InfoContainer>
            <HeaderStyles.LinksContainer>
              {ITEMS?.map(({ name, link }, index) => (
                <HeaderStyles.Link url={link} key={`${name}-${index}`}>
                  {name}
                </HeaderStyles.Link>
              ))}
            </HeaderStyles.LinksContainer>
            <S.ButtonsContainer>
              <HeaderStyles.LoginButton
                href={"https://portal.gocopia.com/login"}
                target="_blank"
              >
                {/*<LoginIcon />*/}
                Log In Donors
              </HeaderStyles.LoginButton>
              <S.Button
                href={"https://connect.gocopia.com/#/"}
                target="_blank"
                className="darkBorder"
              >
                {/*<LoginIcon />*/}
                Log In Nonprofits
              </S.Button>
            </S.ButtonsContainer>
          </S.InfoContainer>
        </Container>
      </S.Wrapper>
    </Fade>
  )
}

export default MenuMobile
